import { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  fill1?: string;
  fill2?: string;
  fill3?: string;
}

const TradeData = (props: IconProps) => {
  const {
    fill1 = 'var(--brand-bg-primary)',
    fill2 = 'var(--brand-bg-primary)',
    fill3 = 'var(--brand-bg-primary)',
    height,
    width,
    className,
  } = props;
  return (
    (<svg
      width={height || '25'}
      height={width || '25'}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-palette="TradeData">
      <path
        d="M5.293 0.719968C6.705 0.529968 8.514 0.529968 10.823 0.529968H10.937C13.246 0.529968 15.055 0.529968 16.466 0.719968C17.911 0.913968 19.051 1.31897 19.946 2.21397C20.84 3.10897 21.246 4.24897 21.44 5.69297C21.63 7.10497 21.63 6.91397 21.63 9.22297V9.33697L20.13 9.27997C20.13 6.90197 20.128 7.19397 19.954 5.89397C19.782 4.61497 19.455 3.84497 18.886 3.27497C18.316 2.70597 17.545 2.37797 16.266 2.20597C14.966 2.03197 13.258 2.02997 10.88 2.02997C8.502 2.02997 6.794 2.03197 5.494 2.20597C4.215 2.37797 3.445 2.70497 2.875 3.27497C2.306 3.84497 1.978 4.61497 1.806 5.89397C1.632 7.19397 1.63 8.90197 1.63 11.28C1.63 13.658 1.632 15.366 1.806 16.666C1.978 17.945 2.305 18.715 2.874 19.285C3.444 19.854 4.215 20.182 5.494 20.354C6.794 20.528 6.502 20.53 8.88 20.53L8.93701 22.03H8.823C6.514 22.03 6.705 22.03 5.294 21.84C3.849 21.646 2.709 21.241 1.814 20.346C0.920005 19.451 0.514005 18.311 0.320005 16.867C0.130005 15.455 0.130005 13.646 0.130005 11.337V11.223C0.130005 8.91397 0.130005 7.10497 0.320005 5.69397C0.514005 4.24897 0.919005 3.10897 1.814 2.21397C2.709 1.31997 3.849 0.913968 5.293 0.719968Z"
        fill={fill1}
      />
      <path
        d="M11.63 7.27997C11.63 7.69397 11.966 8.02997 12.38 8.02997H13.07L11.057 10.043C11.0338 10.0662 11.0062 10.0847 10.9759 10.0973C10.9455 10.1099 10.9129 10.1164 10.88 10.1164C10.8472 10.1164 10.8146 10.1099 10.7842 10.0973C10.7538 10.0847 10.7263 10.0662 10.703 10.043L9.11704 8.45697C8.78888 8.12905 8.34395 7.94484 7.88004 7.94484C7.41612 7.94484 6.97119 8.12905 6.64304 8.45697L4.35004 10.75C4.27635 10.8186 4.21725 10.9014 4.17626 10.9934C4.13526 11.0854 4.11322 11.1847 4.11144 11.2854C4.10967 11.3861 4.12819 11.4862 4.16591 11.5796C4.20363 11.673 4.25978 11.7578 4.331 11.829C4.40222 11.9002 4.48705 11.9564 4.58044 11.9941C4.67383 12.0318 4.77386 12.0503 4.87456 12.0486C4.97526 12.0468 5.07458 12.0247 5.16657 11.9837C5.25857 11.9428 5.34137 11.8837 5.41004 11.81L7.70304 9.51697C7.72626 9.49369 7.75385 9.47522 7.78422 9.46261C7.81459 9.45001 7.84715 9.44352 7.88004 9.44352C7.91292 9.44352 7.94548 9.45001 7.97585 9.46261C8.00623 9.47522 8.03381 9.49369 8.05704 9.51697L9.64304 11.103C9.97119 11.4309 10.4161 11.6151 10.88 11.6151C11.344 11.6151 11.7889 11.4309 12.117 11.103L14.13 9.09097V9.77997C14.13 9.97888 14.2091 10.1696 14.3497 10.3103C14.4904 10.451 14.6811 10.53 14.88 10.53C15.0789 10.53 15.2697 10.451 15.4104 10.3103C15.551 10.1696 15.63 9.97888 15.63 9.77997V7.27997C15.63 7.08106 15.551 6.89029 15.4104 6.74964C15.2697 6.60899 15.0789 6.52997 14.88 6.52997H12.38C12.1811 6.52997 11.9904 6.60899 11.8497 6.74964C11.7091 6.89029 11.63 7.08106 11.63 7.27997Z"
        fill={fill3}
      />
      <rect
        x="12.6"
        y="12.6"
        width="10.8"
        height="10.8"
        rx="1.4"
        stroke={fill2}
        strokeWidth="1.2"
        fill="none"
      />
      <path d="M18.75 18H21L18 21L15 18H17.25V15H18.75V18Z" fill={fill2} />
    </svg>)
  );
};

export default TradeData;
